<div class="pause-loop-backdrop" (click)="onOverlayClick($event)">
    <div class="pause-loop-modal" role="dialog" aria-modal="true" aria-labelledby="pause-title" (click)="$event.stopPropagation()">

        <!-- White top bar — close button only -->
        <div class="pause-loop-topbar">
            <button class="pause-loop-close" type="button" (click)="close($event)" aria-label="Close">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round">
                    <path d="M6 6l12 12M18 6L6 18"></path>
                </svg>
            </button>
        </div>

        <div class="pause-loop-body">

            <!-- Heading -->
            <div class="pause-loop-heading">
                <h2 id="pause-title" class="pause-loop-title">{{'to_pause_loop_modal_title' | translate}}</h2>
                <p class="pause-loop-sub">{{'to_pause_loop_modal_subtitle' | translate}}</p>
            </div>

            <!-- Existing-pause banner -->
            <div *ngIf="hasExistingPause" class="pause-loop-active-banner">
                <div class="pause-loop-banner-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="5" width="18" height="16" rx="3"></rect>
                        <path d="M3 10h18M8 3v4M16 3v4M10 14v4M14 14v4"></path>
                    </svg>
                </div>
                <div class="pause-loop-banner-text">
                    <div class="pause-loop-banner-top">
                        <span class="pause-loop-banner-title">{{'to_pause_loop_active_pause' | translate:{range: existingRangeLabel} }}</span>
                        <span class="pause-loop-chip">{{(pauseStatusChip === 'active' ? 'to_pause_loop_chip_active' : 'to_pause_loop_chip_scheduled') | translate}}</span>
                    </div>
                    <span *ngIf="existingNextSendLabel" class="pause-loop-banner-sub">{{'to_pause_loop_next_send' | translate}} {{existingNextSendLabel}}</span>
                </div>
                <button *ngIf="!showRemoveConfirm"
                        type="button"
                        class="btn btn-outline-danger pause-loop-remove-btn"
                        [disabled]="removing || saving"
                        (click)="requestRemovePause($event)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3"></path>
                    </svg>
                    {{'to_pause_loop_remove' | translate}}
                </button>
            </div>

            <div *ngIf="hasExistingPause && showRemoveConfirm"
                 class="pause-loop-remove-confirm"
                 role="alertdialog"
                 aria-labelledby="pause-remove-confirm-text">
                <p id="pause-remove-confirm-text" class="pause-loop-remove-confirm-text">
                    {{'to_pause_loop_remove_confirm_description' | translate:{date: removeConfirmResumeDate} }}
                </p>
                <div class="pause-loop-remove-confirm-actions">
                    <button type="button"
                            class="pause-loop-keep-btn"
                            [disabled]="removing"
                            (click)="cancelRemovePause($event)">
                        {{'to_pause_loop_keep_pause' | translate}}
                    </button>
                    <button type="button"
                            class="btn btn-outline-danger pause-loop-remove-btn"
                            [disabled]="removing || saving"
                            (click)="confirmRemovePause($event)">
                        {{'to_pause_loop_remove' | translate}}
                    </button>
                </div>
            </div>

            <!-- Period section -->
            <div class="pause-loop-period">
                <div class="pause-loop-period-header">
                    <span class="pause-loop-period-title">{{(hasExistingPause ? 'to_pause_loop_edit_period_title' : 'to_pause_loop_period_title') | translate}}</span>
                    <span class="pause-loop-period-sub">{{(hasExistingPause ? 'to_pause_loop_edit_period_subtitle' : 'to_pause_loop_period_subtitle') | translate}}</span>
                </div>

                <div *ngIf="dateError" role="alert" class="pause-loop-err-box">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                        <circle cx="12" cy="12" r="9"></circle><path d="M12 8v5M12 16h.01"></path>
                    </svg>
                    {{'to_pause_loop_end_after_start' | translate}}
                </div>

                <div class="pause-loop-date-grid">
                    <div class="pause-loop-date-card">
                        <label for="pause-loop-start-date" class="pause-loop-date-label">{{'to_pause_loop_starts' | translate}}</label>
                        <div class="pause-loop-date-input-wrap" [class.err]="dateError" [class.filled]="!!startDateValue">
                            <p-calendar
                                [(ngModel)]="startDateValue"
                                (ngModelChange)="onDatesChange()"
                                [minDate]="minDate"
                                [showIcon]="true"
                                [showOnFocus]="true"
                                [baseZIndex]="2000"
                                dateFormat="dd/mm/yy"
                                placeholder="{{'to_pause_loop_date_placeholder' | translate}}"
                                styleClass="pause-loop-calendar"
                                panelStyleClass="pause-loop-datepicker"
                                icon="bi bi-calendar3"
                                inputId="pause-loop-start-date">
                            </p-calendar>
                        </div>
                    </div>

                    <div class="pause-loop-date-card">
                        <label for="pause-loop-end-date" class="pause-loop-date-label">{{'to_pause_loop_ends' | translate}}</label>
                        <div class="pause-loop-date-input-wrap" [class.err]="dateError" [class.filled]="!!endDateValue">
                            <p-calendar
                                [(ngModel)]="endDateValue"
                                (ngModelChange)="onDatesChange()"
                                [minDate]="endMinDate"
                                [showIcon]="true"
                                [showOnFocus]="true"
                                [baseZIndex]="2000"
                                dateFormat="dd/mm/yy"
                                placeholder="{{'to_pause_loop_date_placeholder' | translate}}"
                                styleClass="pause-loop-calendar"
                                panelStyleClass="pause-loop-datepicker"
                                icon="bi bi-calendar3"
                                inputId="pause-loop-end-date">
                            </p-calendar>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Preview card — rows always visible, greyed out with dashes until dates are valid -->
            <div class="pause-loop-preview">
                <span class="pause-loop-preview-label">{{'to_pause_loop_preview_label' | translate}}</span>
                <div class="pause-loop-preview-box" [class.dimmed]="!datesValid" aria-live="polite">
                    <span class="pause-loop-preview-row">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5E6275" stroke-width="1.8" stroke-linecap="round">
                            <rect x="3" y="5" width="18" height="16" rx="3"></rect><path d="M3 10h18M8 3v4M16 3v4"></path>
                        </svg>
                        {{'to_pause_loop_no_sends' | translate}}
                        <strong>{{datesValid && noSendsLabel ? noSendsLabel : '—'}}</strong>
                    </span>
                    <span class="pause-loop-preview-row">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2D50C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="9"></circle><path d="M8 12l3 3 5-6"></path>
                        </svg>
                        {{'to_pause_loop_next_send' | translate}}
                        <strong class="pause-loop-resume-val">{{datesValid && nextSendLabel ? nextSendLabel : '—'}}</strong>
                        <div class="pause-loop-questionmark-container">
                            <i class="bi bi-question-circle-fill text-warning pause-loop-questionmark"></i>
                            <div class="pause-loop-questionmark-tooltip">{{'to_pause_loop_next_send_tooltip' | translate}}</div>
                        </div>
                    </span>
                </div>
            </div>

            <!-- Info note -->
            <div class="pause-loop-info">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"></circle><path d="M12 11v5M12 8h.01"></path>
                </svg>
                <p>{{'to_pause_loop_info' | translate}}</p>
            </div>

            <!-- Footer — Save only -->
            <div class="pause-loop-actions">
                <button pButton
                        type="button"
                        class="yes-btn"
                        [disabled]="!datesValid || saving || removing"
                        label="{{(hasExistingPause ? 'to_pause_loop_save_changes' : 'to_pause_loop_save') | translate}}"
                        (click)="savePause($event)">
                </button>
            </div>

        </div>
    </div>
</div>
